import { render, staticRenderFns } from "./editNews.vue?vue&type=template&id=8b167f54&scoped=true&"
import script from "./editNews.vue?vue&type=script&lang=js&"
export * from "./editNews.vue?vue&type=script&lang=js&"
import style0 from "./editNews.vue?vue&type=style&index=0&id=8b167f54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b167f54",
  null
  
)

export default component.exports